import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Home from "./Home/Home";
import Navbar from "./Home/Nav";
import AboutCsc from "./AboutUs/AboutCsc";
import Collobration from "./AboutUs/Collobration";
import OurMandates from "./AboutUs/OurMandates";
import StrategicInterventions from "./AboutUs/StrategicInterventions";
import SeedsInputs from "./SeedPestPostHarvest/SeedInput";
import PestManagementDiseases from "./SeedPestPostHarvest/PestManagementDiseas";
import PostHarvestManagement from "./SeedPestPostHarvest/PostHarvestManagment";
import Newsletter from "./PRandMedia/NewsLetters";
import Articles from "./PRandMedia/Articles";
import Videos from "./PRandMedia/Videos";
import AwarenessCampaign from "./ConsumerInformationCenter/AwarenessCampaign";
import SectoralReports from "./ConsumerInformationCenter/SectrolReports";
import AboutCommodity from "./KnowledgeCentre/AboutCommodity";
import StandardPractices from "./KnowledgeCentre/StandardPackageOfPractices";
import RegulationsPolicy from "./KnowledgeCentre/Regulations&Policy";
import ProductionData from "./KnowledgeCentre/ProductionData";
import ImportExportData from "./KnowledgeCentre/Import&ExportData";
import NationalEvents from "./Updates/NationalEvents";
import NationalEventsParticipation from "./Updates/NationalEvents";
import InternationalEventsParticipation from "./Updates/InternationalEvents";
import ContactUs from "./Home/ContactUs";
import ScrollToTop from "./Common/ScrollUp";
import PioneeringMemberCouncil from "./AboutUs/PioneeringMemberCouncil";
import SectoralSeminars from "./Updates/SectoralSeminarsWorkshops";
import PolicyMeetings from "./Updates/PolicyMeetings";
import TrainingKnowledgeExchange from "./Updates/TrainingKnowledgeExchange";
import JoinUs from "./Home/JoinUs";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, // Ensures animations run only once
    });
  }, []);

  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-csc" element={<AboutCsc />} />
        <Route path="/collobration" element={<Collobration />} />
        <Route path="/our-mandates" element={<OurMandates />} />
        <Route
          path="/pioneering-member-council"
          element={<PioneeringMemberCouncil />}
        />
        <Route
          path="/strategic-interventions"
          element={<StrategicInterventions />}
        />
        <Route path="/seeds-inputs" element={<SeedsInputs />} />
        <Route
          path="/pest-managment-diseases"
          element={<PestManagementDiseases />}
        />
        <Route
          path="/post-harvest-managment"
          element={<PostHarvestManagement />}
        />
        <Route path="/news-letters" element={<Newsletter />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/awareness-campaign" element={<AwarenessCampaign />} />
        <Route path="/policy-meetings" element={<PolicyMeetings />} />
        <Route path="/about-commodity" element={<AboutCommodity />} />
        <Route path="/standard-practices" element={<StandardPractices />} />
        <Route path="/regulations-policy" element={<RegulationsPolicy />} />
        <Route path="/import-export-data" element={<ImportExportData />} />
        <Route
          path="/training-knowledge-exchange"
          element={<TrainingKnowledgeExchange />}
        />
        <Route
          path="/sectoral-seminar-training"
          element={<SectoralSeminars />}
        />
        <Route
          path="/national-events"
          element={<NationalEventsParticipation />}
        />
        <Route
          path="/international-events"
          element={<InternationalEventsParticipation />}
        />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/production-data" element={<ProductionData />} />
        <Route path="/join-us" element={<JoinUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
